import React from 'react';
import styled from 'styled-components/macro';
import { RouteComponentProps } from 'react-router-dom';
import { Typography } from '@deeptrue-frontend/ui';

import { Dashboard } from 'components/Layout';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { useFormatMessage } from 'components/IntlProvider';
import { ReactComponent as FailureIcon } from '../../assets/icons/failure.svg';
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow-right.svg';

const { ROUTES } = RouterProvider;

const StyledRootContainer = styled.section`
  display: flex;
  margin-top: 2rem;
  flex: 1;
  flex-direction: column;
`;
const StyledArrowIcon = styled(ArrowIcon)`
  width: 16px;
  margin-right: 8px;
  transform: rotate(180deg);
`;

const StyledMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 7rem;
`;

const FailedPayment = ({ location, history }: RouteComponentProps<any>) => {
  const t = useFormatMessage();
  if ('projectRedirectionAfterPayment' in localStorage) {
    const route = localStorage.projectRedirectionAfterPayment;
    localStorage.removeItem('projectRedirectionAfterPayment');
    history.push(route);
  }

  return (
    <Dashboard title="Payments" location={location}>
      <StyledRootContainer>
        <div
          style={{ display: 'flex', marginTop: '0.5em', cursor: 'pointer' }}
          onClick={() => {
            history.push(ROUTES.PAYMENTS.MAIN);
          }}
        >
          <StyledArrowIcon />
          <Typography variant="copy1" {...{ color: '#008DE9' }}>
            {t('pages.payment.goback', 'Back to payments')}
          </Typography>
        </div>
        <StyledMessageContainer>
          <FailureIcon />
          <Typography variant={'h6'} {...{ marginTop: '2rem' }}>
            {t('pages.payment.failtitle', 'Payment Validation Failed')}
          </Typography>
          <Typography variant={'copy1'} {...{ marginTop: '0.5rem' }}>
            {t(
              'pages.payment.failtext',
              'Please try once again, payment wasn’t processed.'
            )}
          </Typography>
          <a href="mailto:info@deeptrue.com">
            <Typography {...{ color: '#1F5DEA', marginTop: '2rem' }}>
              {t('pages.payment.support', 'CONTACT SUPPORT')}
            </Typography>
          </a>
        </StyledMessageContainer>
      </StyledRootContainer>
    </Dashboard>
  );
};

export default FailedPayment;
